import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { LegacyImage } from "components";
import { useAnchor } from "hooks";
import { HeroSubsection1Content } from "types/graphql/generated";

interface Props {
  content: HeroSubsection1Content;
}

const HeroSubsection1: VFC<Props> = withErrorBoundary(
  ({
    content: {
      heroSubsection1Image: {
        data: { heroSubsection1Image },
      },
    },
  }) => {
    useAnchor("hero-subsection1");

    return (
      <StyledHeroSubsection1 className="hero-subsection1 Content">
        <LegacyImage {...heroSubsection1Image} className="HeroSubsection1__imageIntrinsic" />
        <LegacyImage
          {...heroSubsection1Image}
          layout="fill"
          objectFit="cover"
          objectPosition="30%"
          className="HeroSubsection1__imageFill"
        />
        <img
          src="/images/partner/heroSubsection1-graphic.svg"
          alt="left graphic"
          className="HeroSubsection1__graphic"
        />
      </StyledHeroSubsection1>
    );
  },
  {}
);

const StyledHeroSubsection1 = styled.section`
  position: relative;
  margin-top: -231px;
  padding-top: 64px;

  .HeroSubsection1__imageIntrinsic {
    line-height: 0;
  }

  .HeroSubsection1__imageFill {
    display: none;
  }

  .HeroSubsection1__graphic {
    position: absolute;
    bottom: 0;
    width: 101px;
    height: 283px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .HeroSubsection1__imageIntrinsic {
      display: none;
    }

    .HeroSubsection1__imageFill {
      display: block;
      position: relative;
      width: 100%;
      height: 441px;
    }

    .HeroSubsection1__graphic {
      height: 274px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .HeroSubsection1__imageFill {
      height: 323px;
    }

    .HeroSubsection1__graphic {
      width: 58px;
      height: 156px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    margin-top: 0;

    .HeroSubsection1__imageFill {
      height: 223px;
      width: calc(100% + 48px);
      margin-left: -24px;
      margin-right: -24px;
    }

    .HeroSubsection1__graphic {
      display: none;
    }
  }
`;

gql`
  fragment HeroSubsection1Content on ComponentHeroHeroSubsection1 {
    heroSubsection1Image {
      data {
        heroSubsection1Image: attributes {
          src: hash
          alt: alternativeText
          width: width
          height: height
        }
      }
    }
  }
`;

export { HeroSubsection1 };
export type { Props as HeroSubsection1Props };
